var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Button from 'antd/lib/button';
import 'antd/lib/button/style/index.css';
import Modal from 'antd/lib/modal';
import 'antd/lib/modal/style/index.css';
import ExplanationComponent from '@crimp/lib-score-systems/dist/components/ExplanationComponent';
var ModalScoreSystemExplanation = (function (_super) {
    __extends(ModalScoreSystemExplanation, _super);
    function ModalScoreSystemExplanation(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isVisible: false,
        };
        _this.handleToggleVisible = _this.handleToggleVisible.bind(_this);
        return _this;
    }
    ModalScoreSystemExplanation.prototype.handleToggleVisible = function () {
        this.setState({ isVisible: !this.state.isVisible });
    };
    ModalScoreSystemExplanation.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("a", { onClick: this.handleToggleVisible, style: { textDecoration: 'underline', display: 'block' } },
                React.createElement("small", null, "[see explanation of score format]")),
            React.createElement(Modal, { title: "Explanation for " + this.props.scoreSystemName, visible: this.state.isVisible, onOk: this.handleToggleVisible, onCancel: this.handleToggleVisible, footer: [
                    React.createElement(Button, { key: 'Submit', type: 'primary', onClick: this.handleToggleVisible }, "Got it!"),
                ] },
                React.createElement(ExplanationComponent, { scoreSystemKey: this.props.round.scoreSystem }))));
    };
    return ModalScoreSystemExplanation;
}(React.Component));
export default ModalScoreSystemExplanation;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ModalScoreSystemExplanation.tsx
// module id = 713
// module chunks = 0